// Client for the shared loan import history (Lender.Optimus.Integrations), served for any provider that pulls loans
// into Lender — e.g. `legacy-sftp`. Provider-specific actions (a Legacy SFTP run) live on that provider's own client.

const BASE = '/api/integration-studio/loan-imports';

export class LoanImportsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getImports(providerKey, params) {
    return this.#http.get(`${BASE}/${providerKey}`, { params });
  }

  async getImport(providerKey, id) {
    return this.#http.get(`${BASE}/${providerKey}/${id}`);
  }

  async retryImport(providerKey, id) {
    return this.#http.post(`${BASE}/${providerKey}/${id}/retry`);
  }

  async releaseImport(providerKey, id) {
    return this.#http.post(`${BASE}/${providerKey}/${id}/release`);
  }

  async retryExport(providerKey, id) {
    return this.#http.post(`${BASE}/${providerKey}/${id}/exports/retry`);
  }
}
